const Form017TC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申請資料",
        confirmation: "確認",
    },
    label: {
        note: {
            title: "提示",
            note1: "申請者請準備以格式JPG, PNG或 PDF的有關文件檔案：",
            note2: "(所有文件的總大小不可超過10MB)",
            note3: "申請者需透過已啟用數碼簽署功能的「智方便」帳戶，以辦理網上遞交申報表。",
            note4: "請謹記列印申請表，並將學校發展資料冊一式兩份，經由以下方法遞交：",
            note5: "以專人遞交至香港添馬添美道2號政府總部東翼5樓教育局專業發展及培訓分部〈請在遞交日期最少2個工作天前致電3509 7471登記預約〉；",
            note5a: "或",
            note6: "以掛號郵件寄交至香港添馬添美道2號政府總部東翼5樓教育局專業發展及培訓分部學校領導及專業發展組收",
        },
        termsConditions: "本人已閱讀、理解及同意上述條款及條件。",
        iamSignCheck: "本人理解申請人需要擁有「智方便+」帳戶才能處理申請。",
        refNo: "檔案編號：",
        refNo2: "(只供部門使用)",
        nameOfApplicanEn:
            "申請人姓名（須與申請人之香港身份證上所載相同）(英文)",
        nameOfApplicanCh:
            "申請人姓名（須與申請人之香港身份證上所載相同）(中文)",
        correspondenceAddress: "通訊地址",
        contactTelephone: "電話號碼(學校/辦公室)",
        schoolOrOfficeOption: {
            school: "學校電話號碼",
            office: "辦公室電話號碼",
        },
        contactTelephoneNo: "電話號碼(住宅/手提)",
        HomeOrMobileOption: {
            home: "住宅電話號碼",
            mobile: "手提電話號碼",
        },
        faxNo: "傳真號碼",
        emailAddress: "電郵地址",
        hKIdentityCardOrPassportNo: "香港身份證號碼/護照號碼",
        hKIdentityCardOrPassportNoOption: {
            hkic: "香港身份證號碼",
            passport: "護照號碼",
        },
        registeredTeacherOrPermittedTeacher: "檢定教員/准用教員編號",
        registeredTeacherOrPermittedTeacherOption: {
            registeredTeacher: "檢定教員編號",
            permittedTeacher: "准用教員編號",
        },
        appointmentToPrincipalship: "已獲聘任為校長",
        noteList: "申請人未能提交此申請。",
        noteList1:
            "如你的校長資格認證已經過期，而希望在獲聘為校長前持有有效認證，可申請重新開展校長資格認證程序。",
        confirm: "confirm",
        appointmentToPrincipalshipOption: {
            yes: "是",
            no: "否",
        },
        dateOfAppointmentToPrincipalship: "到任日期",
        schoolOrganisation: "申請人所屬學校/機構",
        schoolOrganisationOption: {
            school: "申請人所屬學校",
            organisation: "申請人所屬機構",
        },
        name: "學校名稱",
        address: "學校地址",
        name1: "機構名稱",
        address1: "機構地址",
        typeOfSchool: "學校類別（如適用）",
        typeOfSchoolOption1: {
            primary: "小學",
            secondary: "中學",
            special: "特殊學校",
        },
        typeOfSchoolOption2: {
            government: "官立",
            aided: "資助",
            dss: "直資",
            caput: "按額資助",
            others: "其他(請說明)",
        },
        // typeOfSchoolOption: {
        //     primary: "小學",
        //     secondary: "中學",
        //     special: "特殊學校",
        //     government: "官立",
        //     aided: "資助",
        //     dss: "直資",
        //     caput: "按額資助",
        //     others: "其他（請說明）",
        // },
        specify: "請說明：",
        issueDateOfCFP: "發出校長資格認證日期",
        header: "請在適當的方格內填上 √",

        declaration: "聲明",
        note1: "",
        // declarationContentList: [
        //     "本人已閱讀及明白 「 學校發展資料冊撰寫指引 」；",
        //     "本人在申請表填寫的個人資料，以及就本次申請呈交的學校發展資料冊當中的所有事實資料，均屬真實準確；以及",
        //     "本學校發展資料冊的內容，除引用其他來源資料的部分以外， 全屬本人作品，而所引用的其他來源資料，其出處已妥為註明，所抄錄的部分亦以引文方式標示；本學校發展資料冊符合版權法例。",
        // ],
        declaration1: "本人已閱讀及明白 「 學校發展資料冊撰寫指引 」；",
        declaration2:
            "本人在申請表填寫的個人資料，以及就本次申請呈交的學校發展資料冊當中的所有事實資料，均屬真實準確；以及",
        declaration3:
            "本學校發展資料冊的內容，除引用其他來源資料的部分以外， 全屬本人作品，而所引用的其他來源資料，其出處已妥為註明，所抄錄的部分亦以引文方式標示；本學校發展資料冊符合版權法例",

        errorMsg: {
            nameOfApplicanEn: "請輸入一個有效的申請人姓名(英文)",
            nameOfApplicanCh: "請輸入一個有效的申請人姓名(中文)",
            correspondenceAddress: "請輸入一個有效的通訊地址",
            school: "請輸入一個有效的學校電話號碼",
            office: "請輸入一個有效的辦公室電話號碼",
            home: "請輸入一個有效的住宅電話號碼",
            mobile: "請輸入一個有效的手提電話號碼",
            faxNo: "請輸入一個有效的傳真號碼",
            emailAddress: "請輸入一個有效的電郵地址",
            hkic: "請輸入一個有效的香港身份證",
            passport: "請輸入一個有效的護照號碼",
            registeredTeacher: "請輸入一個有效的檢定教員編號",
            permittedTeacher: "請輸入一個有效的准用教員編號",
            dateOfAppointmentToPrincipalship:
                "請輸入一個今天之前或者之後的日期",
            name: "請輸入一個有效的學校名稱",
            address: "請輸入一個有效的學校地址",
            name1: "請輸入一個有效的機構名稱",
            address1: "請輸入一個有效的機構地址",
            issueDateOfCFP: "請輸入一個有效的發出校長資格認證日期",
            otherInput: "請輸入一個有效的原因",
            E0001: "如果你選擇其他，請寫明原因",
        },
        attachment: "附件",
        completedByEDB: "此欄由教育局填寫",
    },
    submittedDialog: {
        note1: "已成功遞交申請。",
        note2: "請謹記列印",
        note3: "此表格",
        note4: "，並將",
        note5: "學校發展資料冊一式兩份",
        note6: "，經由以下方法遞交： ",
        note7: "以專人遞交至香港添馬添美道2號政府總部東翼5樓教育局專業發展及培訓分部〈請在遞交日期最少2個工作天前致電3509 7471登記預約〉；或",
        note8: "以掛號郵件寄交至",
        note9: "香港添馬添美道2號",
        note10: "政府總部東翼5樓",
        note11: "教育局",
        note12: "專業發展及培訓分部",
        note13: "學校領導及專業發展組收",
    },
};
export default Form017TC;
